import { FC } from 'react';
import { IonSearchbar } from '@ionic/react';
import { AllieIonSearchbarProps } from './Searchbar.types';

export const AllieIonSearchbar: FC<AllieIonSearchbarProps> = (props) => {
  return <IonSearchbar onIonChange={props.onChange} {...props} />;
};
